<template>
  <div class="main-car-details">
    <img
      v-if="carDetails.main_image_url"
      :src="carDetails.main_image_url"
      alt=""
    />
    <img v-else src="../assets/images/default.jpg" alt="" />
    <h2 :title="carDetails.headline">{{ carDetails.headline }}</h2>
    <u class="main-car-details__delivery-label">
      <li class="onlinekauf-label">
          <i class="fas fa-check" /> onlinekauf
      </li>
      <li>
          <i class="fas fa-check-circle" /> sofort verfügbar
      </li>
    </u>
    <ul class="main-car-details__list">
      <li>
        <img
          src="../assets/images/car-icons/mileage.svg"
          alt="Kilometerstand"
        />
        {{ carDetails.mileage_km }}
      </li>
      <li>
        <img
          src="../assets/images/car-icons/fueltype.svg"
          alt="Kraftstoffart"
        />
        {{ carDetails.fueltype_name }}
      </li>
      <li>
        <img
          src="../assets/images/car-icons/registration.svg"
          alt="Erstzulassung"
        />
        EZ {{ carDetails.registration_date }}
      </li>
      <li>
        <img src="../assets/images/car-icons/geartype.svg" alt="Getriebeart" />
        {{ carDetails.geartype_name }}
      </li>
      <li>
        <img src="../assets/images/car-icons/power.svg" alt="Leistung" />
        {{ carDetails.power }}
      </li>
      <li><button @click="openModal">alle Fahrzeugdetails</button></li>
    </ul>
    <div class="car-emission-info">
      <p class="emission">
        <span style="display:flex;align-items:center;margin-bottom:15px;" v-if="carDetails.wltp_electric_motor_range">
          <img src="../assets/images/car-icons/battery-consumption.svg" style="width: 12px;margin:0 10px 0 0;" alt="Reichweite" />
          {{ carDetails.wltp_electric_motor_range }} km Reichweite
        </span>
        <span v-if="carDetails.consumption_co2_emission_data">
          {{ carDetails.consumption_co2_emission_data }}
        </span>
        <!-- <span v-if="carDetails.consumption"
          >{{ carDetails.consumption }} (komb.)*,
        </span>
        <span v-if="carDetails.emission"
          >{{ carDetails.emission }} (komb.)*,
        </span>
        <span v-if="carDetails.electro"
          >{{ carDetails.electro }} (komb.)*
        </span> -->
      </p>
    </div>
    <CarDetailsPrint :car="car" :car-details="carDetails" />
    <p
      class="car-emission-note"
    >
      * Weitere Informationen zum offiziellen Kraftstoffverbrauch und den
      offiziellen spezifischen CO2-Emissionen neuer Personenkraftwagen können
      dem »Leitfaden über den Kraftstoffverbrauch, die CO2-Emissionen und den
      Stromverbrauch neuer Personenkraftwagen «entnommen werden, der an allen
      Verkaufsstellen und bei der Deutschen Automobil Treuhand GmbH unter
      <a href="https://www.dat.de" target="_blank">www.dat.de</a> unentgeltlich
      erhältlich ist.
    </p>
    <!-- <span class="prices-info">
      alle Preise inkl. USt
    </span> -->
    <dl class="main-car-details__price">
      <div>
        <dt>Fahrzeugpreis</dt>
        <dd>{{ formattedPrice(car.price.customer, 2) }} <small v-if="car.vatable">inkl. Mwst.</small> <span v-if="car.vatable">Mwst. ausweisbar</span></dd>
      </div>
      <!-- <div
        v-if="
          order && order.delivery_method && order.delivery_method !== 'to_pickup'
        "
      >
        <dt>Überführung per Spedition</dt>
        <dd>
          ab {{ commercialBuyer ? formattedPrice(order.car_info.online_offer_services.all_services_b2b.delivery.transporter) : formattedPrice(order.car_info.online_offer_services.all_services.delivery.transporter) }}
        </dd>
      </div> -->
    </dl>
    <div v-if="currentOrderStep === '1'" class="main-car-details__buy-now">
      <p class="headline">Barkauf oder Finanzierung</p>
      <div class="buy-now__item">
        <span class="heading">Barkauf</span
        ><span>{{ formattedPrice(car.price.customer, 2) }}</span>
      </div>
      <div class="buy-now__item">
        <span class="heading">oder Finanzierung</span
        ><span
          >ab
          {{
            formattedPrice(car.initial_financing_offer.monthly_rate, 2)
          }}
          mtl.</span
        >
      </div>
      <!-- <div
        v-if="car && car.online_offer_services.free_delivery"
        class="buy-now__item"
      >
        <span class="heading">Lieferung</span>
        <span>
          € 0 ,- 
          <span v-if="!commercialBuyer" class="strike">ab € {{ order.car_info.online_offer_services.all_services.delivery.transporter}} ,-</span>
          <span v-else class="strike">ab € {{ order.car_info.online_offer_services.all_services_b2b.delivery.transporter}} ,-</span>
        </span>
      </div>
      <div v-else class="buy-now__item">
        <span class="heading">Lieferung</span>
        <span v-if="!commercialBuyer">ab € {{ order.car_info.online_offer_services.all_services.delivery.transporter}} ,-</span>
        <span v-else>ab € {{ order.car_info.online_offer_services.all_services_b2b.delivery.transporter}} ,-</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@/utils/price-helpers";
import CarDetailsPrint from "./print/CarDetailsPrint";
import { SELF, STANDARD, WITH_PLATES } from "./ApprovalPkwForm.vue";

export default {
  props: ["carDetails", "car", "currentOrderStep", "order"],
  components: {
    CarDetailsPrint,
  },
  data: () => ({
    SELF, STANDARD, WITH_PLATES,
  }),
  computed: {
    isMobile() {
      return window.innerWidth <= 520;
    },
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
  },
  methods: {
    openModal() {
      this.$emit("openModal");
    },
    formattedPrice(num) {
      return `€ ${formatPrice(num)} ,-`;
    },
  },
};
</script>

<style lang="scss" scoped>
.prices-info {
  display:flex;
  justify-content: flex-end;
  font-size: 14px;
  line-height: 18px;
  margin-bottom:-10px;
}
.main-car-details {
  &__price {
    padding: 25px 20px;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 700;
    background-color: $light-gray;

    small {
      font-weight: 400;
      font-size: 14px;
    }

    span {
      display:block;
      font-weight: 400;
      font-size: 14px;
    }
    
    @include breakpoint(mini) {
      font-size: 16px;
    }
    @include breakpoint(medium) {
      font-size: 14px;
    }
    @include breakpoint(desktop) {
      font-size: 16px;
    }
    > div {
      display: flex;
      flex-wrap:wrap;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      dt {
        // width: 130px;
        margin-bottom:10px;
        display:flex;
        align-items:center;

        i {
          margin-left:3px;
        }

        &:last-of-type {
          margin-bottom:0;
        }
        // @include breakpoint(mini) {
        //   width: 160px;
        // }
        // @include breakpoint(medium) {
        //   width: 110px;
        // }
        @include breakpoint(desktop) {
          // width: 160px;
          line-height: 22px;
        }
      }
      dd {
        margin:0;
        line-height: 22px;
      }
    }
  }
  &__buy-now {
    border: 1px solid #d0d0d0;
    padding: 40px 30px;
    background-color: #ffffff;
    margin-bottom: 20px;

    .headline {
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
    }

    .buy-now__item {
      padding: 10px 0;

      .heading {
        display: inline-block;
        min-width: 140px;
      }

      .strike {
        color: $red;
        font-weight: 700;
        position: relative;

        &:before {
          content: "";
          display: inline-block;
          background: $red;
          height: 1px;
          width: 110%;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }
  }
  &__list {
    margin: 20px 0 0;
    columns: 2;
    li {
      margin-bottom: 14px;
      font-size: 16px;
      position: relative;
      padding-left: 35px;

      &:last-of-type {
        padding-left: 0;
      }

      @include breakpoint(medium) {
        font-size: 14px;
      }

      @include breakpoint(desktop) {
        margin-bottom: 20px;
        font-size: 16px;
      }

      img {
        margin-right: 10px;
        height: 16px;
        width: auto;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    i {
      margin-right: 10px;
      color: #d8d8d8;
    }

    button {
      padding: 0;
      color: $red;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  img {
    display: block;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }
  h2 {
    margin-top: 15px;
    font-size: 18px;
    font-weight: 700;
    padding: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__delivery-label {
    position: relative;
    margin-top: 5px;
    list-style: none;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 20px;

    li {
      font-size: 14px;
      line-height: 14px;
      font-weight: 700;
      color: $green;
    }
  }

  .onlinekauf-label {
    background: $blue;
    color:white;
    border-radius:30px;
    padding: 5px 15px;
    font-weight: normal;
  }

  .car-emission-info {
    margin-bottom: 20px;
    .emission {
      line-height: 1.4;
    }
  }

  .car-emission-note {
    font-size: 10px;
    line-height: 14px;
    color: $main;
    margin-bottom: 20px;
    a {
      color: $red;
    }
  }
}
</style>
